import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import styles from './subscriptionOverlay.module.scss';

const SubscriptionOverlay = ({ isActive, positionType = 'fixed', closeNavigatePath = null }) => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    if (!isActive) return null;

    const handleOverlayClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true);
    };

    const handleSubscribe = () => {
        setShowModal(false);
        navigate('/user-setting');
    };

    const handleClose = () => {
        setShowModal(false);
        if (closeNavigatePath) {
            navigate(closeNavigatePath);
        }
    };

    const overlayClassName = positionType === 'absolute'
        ? styles.invisibleOverlayAbsolute
        : styles.invisibleOverlay;

    return (
        <>
            {/* Invisible layer to catch all user interactions */}
            <div
                className={overlayClassName}
                onClick={handleOverlayClick}
                onMouseDown={handleOverlayClick}
                onTouchStart={handleOverlayClick}
            />

            {/* Modal that shows when user tries to interact */}
            <Modal
                open={showModal}
                onCancel={handleClose}
                footer={null}
                centered
                closable={true}
                zIndex={10000}
            >
                <div className={styles.modalContent}>
                    <div className={styles.iconContainer}>
                        <svg
                            width="64"
                            height="64"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5zm0 5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 10c-2.67 0-8 1.34-8 4v1h16v-1c0-2.66-5.33-4-8-4z"
                                fill="#faad14"
                            />
                        </svg>
                    </div>
                    <h2 className={styles.title}>Subscription Required</h2>
                    <p className={styles.message}>
                        You need an active subscription to access this feature.
                        Please subscribe to a package to unlock all Prepal's features.
                    </p>
                    <div className={styles.buttonGroup}>
                        <button
                            className={styles.subscribeButton}
                            onClick={handleSubscribe}
                        >
                            Subscribe Now
                        </button>
                        <button
                            className={styles.cancelButton}
                            onClick={handleClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default SubscriptionOverlay;
